/* ============================================================
   plugcaptions — comfort layer (pc-comfort)
   Back-to-top button: floating gold circle, appears after two
   screens of scrolling, smooth-scrolls home. Self-contained.
   ============================================================ */
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) return;
  if (document.getElementById('pcTop')) return;

  // mirrors the mystery-discount pill: same bottom line, same near-black
  // fill, same soft gold ring, white glyph
  var css = '' +
    '#pcTop{position:fixed;right:1.4rem;bottom:1rem;z-index:9000;width:4rem;height:4rem;border-radius:50%;' +
    'display:flex;align-items:center;justify-content:center;padding:0;cursor:pointer;' +
    'background:rgba(8,8,8,.92);border:1px solid rgba(200,149,25,.72);color:#fff;' +
    '-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);box-shadow:0 6px 20px rgba(0,0,0,.4);' +
    'opacity:0;visibility:hidden;transform:translateY(12px);' +
    'transition:opacity .35s ease,visibility .35s ease,transform .4s cubic-bezier(.22,.61,.36,1),background .2s ease,color .2s ease}' +
    '#pcTop.is-visible{opacity:1;visibility:visible;transform:none}' +
    '#pcTop:hover{background:#c89519;color:#000;border-color:#c89519}' +
    '#pcTop svg{width:1.7rem;height:1.7rem}' +
    '@media (max-width:749px){#pcTop{right:1rem;bottom:1rem;width:3.6rem;height:3.6rem}}';

  var st = document.createElement('style');
  st.id = 'pcTop-css';
  st.textContent = css;
  document.head.appendChild(st);

  var btn = document.createElement('button');
  btn.id = 'pcTop';
  btn.type = 'button';
  btn.setAttribute('aria-label', 'Back to top');
  btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 14 12 8 18 14"/></svg>';
  document.body.appendChild(btn);

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });

  var shown = false, ticking = false;
  function update() {
    ticking = false;
    var show = window.scrollY > window.innerHeight * 2;
    if (show !== shown) {
      shown = show;
      btn.classList.toggle('is-visible', show);
    }
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }, { passive: true });
  update();
})();
